import { useEffect, useRef, useState } from "react";

import useAmplitude from "@hooks/useAmplitude";
import HelpButton from "@img/HelpButton.svg";

import Modal from "./Modal";

const Container = () => {
  const [isOpen, setIsOpen] = useState(false);
  const helpButtonRef = useRef<HTMLButtonElement>(null);
  const { logEvent } = useAmplitude();
  const toggleOpen = () => {
    logEvent("HELP_MODAL_TOGGLE", { ACTION_OPEN: !isOpen });
    setIsOpen(!isOpen);
  };
  // The close button unmounts with the panel; keep keyboard focus from dropping to <body>.
  const closePanel = () => {
    toggleOpen();
    helpButtonRef.current?.focus();
  };

  useEffect(() => {
    if (!isOpen) {
      return;
    }
    const closeOnEscape = (event: KeyboardEvent) => {
      if (event.key === "Escape") {
        closePanel();
      }
    };
    document.addEventListener("keydown", closeOnEscape);
    return () => document.removeEventListener("keydown", closeOnEscape);
  }, [isOpen]);

  return (
    <>
      <button
        ref={helpButtonRef}
        type="button"
        className="help-button"
        aria-label="Help"
        onClick={toggleOpen}
        aria-expanded={isOpen}
      >
        <img src={HelpButton} alt="" />
        <span>Help</span>
      </button>
      {isOpen && <Modal setOpenHelpModal={closePanel} />}
    </>
  );
};

export default Container;
